import React from "react";
import Slider from "react-slick";
import "./BannerSlider.css";
import bannercow1 from "../Assets/banner-cow-1.png";
import bannercow2 from "../Assets/banner-cow-2.png";
import bannercow3 from "../Assets/banner-cow-3.png";

const BannerSlider = () => {
  const slides = [
    {
      title: "Nature’s Promise, Your Nourishment",
      desc: "Nurturing earth, empowering farmers, caring cows, nourishing every home.",
      img: bannercow1,
      btn: "Learn More",
    },
    {
      title: "Pure Goodness from Healthy Farms",
      desc: "We ensure every product carries the freshness of nature.",
      img: bannercow2,
      btn: "Explore Now",
    },
    {
      title: "From Our Farms to Your Home",
      desc: "Driven by quality, delivered with care.",
      img: bannercow3,
      btn: "Shop Now",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    arrows: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="vangal-banner-wrapper">
      <div className="vangal-banner-bg"></div>

      <Slider {...settings}>
        {slides.map((item, index) => (
          <div className="vangal-banner-slide" key={index}>
            <div className="vangal-banner-content anim anim-top">
              <h1>{item.title}</h1>
              <p>{item.desc}</p>
              <a href="/contact">
  <button>{item.btn}</button>
</a>
            </div>

            <div className="vangal-banner-image anim anim-bottom">
              <img src={item.img} alt="cow" />
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default BannerSlider;
